(function () {
  var LINK_SELECTOR = '.card-swatches__link[data-variant-image]';

  // Preload all variant images into browser cache for instant hover swap
  function preloadSwatchImages() {
    var links = document.querySelectorAll(LINK_SELECTOR);
    for (var i = 0; i < links.length; i++) {
      var url = links[i].getAttribute('data-variant-image');
      if (url) {
        var img = new Image();
        img.src = url;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preloadSwatchImages);
  } else {
    preloadSwatchImages();
  }

  document.addEventListener('mouseover', function (e) {
    var link = e.target.closest(LINK_SELECTOR);
    if (!link) return;

    var wrapper = link.closest('.card-wrapper');
    if (!wrapper) return;

    var mediaContainer = wrapper.querySelector('.card__media .media');
    if (!mediaContainer) return;

    var imgs = mediaContainer.querySelectorAll('img');
    var primaryImg = imgs[0];
    if (!primaryImg) return;

    var variantUrl = link.getAttribute('data-variant-image');
    if (!variantUrl) return;

    // Store originals on first hover
    if (!wrapper.hasAttribute('data-original-src')) {
      wrapper.setAttribute('data-original-src', primaryImg.getAttribute('src') || '');
      wrapper.setAttribute('data-original-srcset', primaryImg.getAttribute('srcset') || '');
    }

    // Swap primary image to variant image
    primaryImg.setAttribute('src', variantUrl);
    primaryImg.removeAttribute('srcset');

    // Add class to force primary visible and hide secondary (overrides theme CSS hover)
    wrapper.classList.add('card-swatches--active');
  });

  document.addEventListener('mouseout', function (e) {
    var link = e.target.closest(LINK_SELECTOR);
    if (!link) return;

    // Still inside the same link — ignore
    if (link.contains(e.relatedTarget)) return;

    var wrapper = link.closest('.card-wrapper');
    if (!wrapper) return;

    var mediaContainer = wrapper.querySelector('.card__media .media');
    if (!mediaContainer) return;

    var imgs = mediaContainer.querySelectorAll('img');
    var primaryImg = imgs[0];
    if (!primaryImg) return;

    var originalSrc = wrapper.getAttribute('data-original-src');
    var originalSrcset = wrapper.getAttribute('data-original-srcset');

    if (originalSrc !== null) {
      primaryImg.setAttribute('src', originalSrc);
      if (originalSrcset) {
        primaryImg.setAttribute('srcset', originalSrcset);
      }
      wrapper.removeAttribute('data-original-src');
      wrapper.removeAttribute('data-original-srcset');
    }

    // Remove override — let theme CSS secondary-image hover work normally again
    wrapper.classList.remove('card-swatches--active');
  });
})();
